module.exports = __webpack_public_path__ + "img/fore.57a96911.png";